import classNames from 'classnames';

import styles from './TextArea.module.scss';

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  innerRef?: React.Ref<HTMLTextAreaElement>;
  isStatic?: boolean;
}

const TextArea: React.FC<Props> = ({
  innerRef,
  isStatic = false,
  className,
  ...attrs
}) => (
  <textarea
    ref={innerRef}
    className={classNames(
      styles.textarea,
      {
        [styles.isStatic]: isStatic,
      },
      className,
    )}
    {...attrs}
  />
);

export default TextArea;
